import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import { mostrarPrestamoById} from '../../redux/reducers/prestamosReducer';
import {cancelarPrestamo} from "../../services";
import {
    Dialog,
    DialogActions,
    DialogContent,
    Checkbox,
    FormControlLabel,
    Button,
    TextField,
    Theme
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Strings from "../../assets/strings";
import {MostrarError,LoadingProgress,TopBarDialog} from "../../components";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IPrestamoDetalle} from "../../redux/types/IPrestamo";
const useStyles = makeStyles((theme:Theme) => ({
  cancelBox:{
    "& header":{
        backgroundColor: theme.palette.error.light,
    }
  }
}));


function CancelDialog() {
    const navigate = useNavigate()
    let {id:prestamoId, pagos} = useAppSelector(state => state.prestamos.byId || {} as IPrestamoDetalle);
    let dispatch = useAppDispatch();

    const classes = useStyles();
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const [state, setState] = useState({nota:"", anularPagos:false});

    const submit = () => {
        setLoading(true)
        cancelarPrestamo(prestamoId!,state.nota,state.anularPagos).then(res=>{
            setLoading(false)
            if(state.anularPagos || !pagos?.some(p=>!p.fechaAnulacion)){
                navigate("/prestamos",{replace: true})
            }else{
                dispatch(mostrarPrestamoById(prestamoId!))
                navigate(-1)
            }
        }).catch(error=>{
            setError(error.response)
            setLoading(false)
        })
    };
    const handleChange = (e:React.ChangeEvent<HTMLInputElement>) => {
          const {name,value,checked} = e.target;
          if(name === "anularPagos"){
            setState({...state,  [name]: checked });
          }else{
            setState({...state,  [name]: value });
          }
    };

    return (
        <Dialog open={true} onClose={()=>navigate(-1)} className={classes.cancelBox} maxWidth={"xs"} fullWidth>
          <TopBarDialog title={Strings.cancelPreMsj} onClose={()=>navigate(-1)} />

            <MostrarError errors={error}/>

            <DialogContent className="content">
            {loading && <LoadingProgress />}
                {state.anularPagos?(
                    <p>{Strings.prestamoSeEliminara}</p>
                ):(
                    <TextField
                        label={Strings.comentario}
                        multiline
                        name="nota"
                        maxRows="4"
                        value={state.nota}
                        fullWidth
                        variant={"outlined"}
                        onChange={handleChange}
                        inputProps={{maxLength: 100}}

                    />
                )}

            <FormControlLabel
                control={<Checkbox name="anularPagos" checked={state.anularPagos} onChange={handleChange}/>}
                label={Strings.eliminar+" "+Strings.pagos} />
          </DialogContent>
          <DialogActions>
              <Button type={"button"} color="warning" variant={"text"} onClick={()=>navigate(-1)}>
                  {Strings.abordar}
              </Button>
              <Button onClick={submit} color="error" disabled={loading}  variant={"outlined"}>
                  {Strings.confirmar}
              </Button>
          </DialogActions>
        </Dialog>
    );
}

export default CancelDialog;



